module.exports = __webpack_public_path__ + "static/media/36-13.28e838d2.mp3";